addEventListener('load', _ => {
    if(document.querySelectorAll('[data-toggle="modal"]') && sessionStorage.getItem('modalOpened') == null){
        setTimeout(modalOpen, 20000)
    }
})

function modalOpen(){
    const modalBtn = document.querySelectorAll('[data-toggle="modal"]')
        modalBtn.forEach(btn => {
            btn.click();
            sessionStorage.setItem('modalOpened', 1);
        });
}